import React from 'react';
import { FlameIcon } from 'lucide-react';
export function OfferBar() {
  return <a href="#oferta" className="flex w-full items-center justify-center gap-2 bg-ink px-3 py-2 text-center text-[10px] font-bold uppercase tracking-[0.1em] text-gold-light transition-colors duration-150 ease-out hover:text-white sm:py-2.5 sm:text-sm sm:tracking-[0.14em]" data-id="element-92" data-mp="130ld17j4w0r4">
      <FlameIcon className="h-3.5 w-3.5 shrink-0 text-gold-bright sm:h-4 sm:w-4" aria-hidden="true" data-id="element-93" data-mp="fb99an6kskw7" />
      <span data-id="element-94" data-mp="k1pl62uqzygg">Oferta especial · Acceso inmediato · Precio de lanzamiento</span>
    </a>;
}